"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combine = combine;
exports.getActualMetricSettings = getActualMetricSettings;
exports.getChartTypes = void 0;
exports.getComparisonOptions = getComparisonOptions;
exports.getCrosstabComparisonOptions = getCrosstabComparisonOptions;
exports.getDiff = getDiff;
exports.getInitialMetricSettings = getInitialMetricSettings;
exports.getMetricSettingsToSave = getMetricSettingsToSave;
exports.getVisualizeAsOptions = getVisualizeAsOptions;
var _cccisdVisualize = require("cccisd-visualize");
var _deepObjectDiff = require("deep-object-diff");
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _unset2 = _interopRequireDefault(require("lodash/unset"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _statsBars = _interopRequireDefault(require("cccisd-icons/stats-bars4"));
var _pieChart = _interopRequireDefault(require("cccisd-icons/pie-chart3"));
var _statsDots = _interopRequireDefault(require("cccisd-icons/stats-dots"));
var _meterMedium = _interopRequireDefault(require("cccisd-icons/meter-medium"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu3"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function getComparisonOptions(metric) {
  var excludedOptions = new Set();
  var result = [{
    label: 'No Comparison',
    value: 'none'
  }, {
    label: 'Crosstab',
    value: 'crosstab'
  }, {
    label: 'Group',
    value: 'grouptype'
  }, {
    label: 'Over Time',
    value: 'overtime'
  }].filter(function (item) {
    return !excludedOptions.has(item.value);
  });
  return result;
}
function getCrosstabComparisonOptions(metrics, currentMetric) {
  var options = metrics.filter(function (metric) {
    return metric["enum"] || ['boolean', 'integer'].includes(metric.type);
  }).map(function (metric) {
    var isCurrentMetric = metric.variableId === currentMetric.variableId;
    return {
      value: "variables.".concat(metric.reportHeader),
      label: "Metric - ".concat(metric.reportHeader).concat(isCurrentMetric ? ' (Selected Metric)' : ''),
      disabled: isCurrentMetric
    };
  });
  return options;
}
function getVisualizeAsOptions(_ref) {
  var metric = _ref.metric,
    metricSettings = _ref.metricSettings,
    crossMetric = _ref.crossMetric;
  var isMean = function () {
    if (!metric.statisticType.includes('numeric')) {
      return false;
    }
    if (metricSettings.comparison === 'overtime') {
      return true;
    }
    if (metricSettings.comparison === 'crosstab' && crossMetric && crossMetric.statisticType.includes('categorical')) {
      return true;
    }
    return false;
  }();
  var result = [{
    label: 'Distribution',
    value: 'dist'
  }];
  if (isMean && (['MC - select one', 'MC - select multiple', 'number', 'integer', 'slider'].includes(metric.questionType) || metric.type === 'formula')) {
    result.push({
      label: 'Mean',
      value: 'mean'
    });
  }
  return result;
}
var getChartTypes = function getChartTypes(_ref2) {
  var metric = _ref2.metric,
    metricSettings = _ref2.metricSettings,
    crossMetric = _ref2.crossMetric;
  var statisticType = metric.statisticType;
  var visualizeAs = metricSettings.visualizeAs,
    comparison = metricSettings.comparison;
  var questionTypesWithoutCharts = ['openEnded', 'date'];
  var options = [{
    name: 'bar',
    label: 'Bar',
    icon: _statsBars["default"],
    isDist: statisticType.includes('categorical'),
    isMean: true
  }, {
    name: 'line',
    label: 'Line',
    icon: _statsDots["default"],
    isDist: true,
    isMean: true
  }, {
    name: 'pie',
    label: 'Pie',
    icon: _pieChart["default"],
    isDist: comparison !== 'crosstab' && comparison !== 'grouptype' && statisticType.includes('categorical'),
    isMean: false
  }, {
    name: 'gauge',
    label: 'Gauge',
    icon: _meterMedium["default"],
    isDist: false,
    isMean: false
  }, {
    name: 'bullet',
    label: 'Bullet',
    icon: _menu["default"],
    isDist: false,
    isMean: false
  }];
  return options.filter(function (item) {
    if (questionTypesWithoutCharts.includes(metric.questionType)) {
      return false;
    }
    return visualizeAs === 'dist' ? item.isDist : item.isMean;
  });
};
exports.getChartTypes = getChartTypes;
function getDefaultNivoOptionsForChartTypes(common) {
  return {
    bar: _objectSpread(_objectSpread(_objectSpread({}, _cccisdVisualize.Bar.initialValues), common), {}, {
      keys: ['Responses'],
      showLegend: false,
      enableGridX: false,
      enableGridY: true,
      padding: 0.6
    }),
    line: _objectSpread(_objectSpread(_objectSpread({}, _cccisdVisualize.Line.initialValues), common), {}, {
      keys: ['Responses'],
      showLegend: false,
      enableGridX: true,
      enableGridY: true
    }),
    pie: _objectSpread(_objectSpread(_objectSpread({}, _cccisdVisualize.Pie.initialValues), common), {}, {
      showLegend: false
    }),
    swarm: _objectSpread(_objectSpread(_objectSpread({}, _cccisdVisualize.Swarm.initialValues), common), {}, {
      keys: ['Responses'],
      enableGridX: true,
      enableGridY: false,
      pointSize: 10
    }),
    gauge: _objectSpread(_objectSpread({}, _cccisdVisualize.Gauge.initialValues), common),
    bullet: _objectSpread(_objectSpread({}, _cccisdVisualize.Bullet.initialValues), common),
    none: {}
  };
}
function getInitialMetricSettings(metric) {
  var colors = 'pastel2';
  var comparison = 'none';
  var theme = {
    fontSize: 14
  };
  var nivoOptions = getDefaultNivoOptionsForChartTypes({
    theme: theme,
    colors: colors
  });
  var additionalSettings = {
    showLabel: true,
    showQuestion: true,
    showTotalResponses: true,
    showTable: true,
    showSummaryStats: true,
    chartHeight: 425,
    enableRollupThreshold: true,
    rollupThresholdValue: 10,
    aboveChart: '',
    belowChart: ''
  };
  switch (metric.questionType) {
    case 'MC - select one':
    case 'MC - select multiple':
      return _objectSpread({
        visualizeAs: 'dist',
        comparison: comparison,
        compareWith: '',
        compareByGroupType: '',
        chartType: 'bar',
        nivoOptions: nivoOptions
      }, additionalSettings);
    case 'number':
      // TODO
      return;
    case 'integer':
      return _objectSpread({
        visualizeAs: 'dist',
        comparison: comparison,
        compareWith: '',
        compareByGroupType: '',
        chartType: 'bar',
        nivoOptions: nivoOptions
      }, additionalSettings);
    case 'slider':
      return _objectSpread({
        visualizeAs: 'dist',
        comparison: comparison,
        compareWith: '',
        compareByGroupType: '',
        chartType: 'line',
        nivoOptions: nivoOptions
      }, additionalSettings);
    case 'boolean':
      return _objectSpread({
        visualizeAs: 'dist',
        comparison: comparison,
        compareWith: '',
        compareByGroupType: '',
        chartType: 'bar',
        nivoOptions: nivoOptions
      }, additionalSettings);
    case 'timestamp':
      return _objectSpread({
        visualizeAs: 'dist',
        comparison: comparison,
        compareWith: '',
        compareByGroupType: '',
        chartType: 'bar',
        nivoOptions: nivoOptions
      }, additionalSettings);
    default:
      if (metric.type === 'formula') {
        return _objectSpread({
          visualizeAs: 'dist',
          comparison: comparison,
          compareWith: '',
          compareByGroupType: '',
          chartType: 'line',
          nivoOptions: nivoOptions
        }, additionalSettings);
      }
      return _objectSpread({
        visualizeAs: 'dist',
        comparison: comparison,
        compareWith: '',
        compareByGroupType: '',
        chartType: 'none',
        nivoOptions: nivoOptions
      }, additionalSettings);
  }
}
function getActualMetricSettings(metric, settings) {
  var overrideInitialSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // as we removed theme custom color from UI and code, we need to remove it from already saved settings, just to avoid breaking changes
  var adjustedSettings = function () {
    if ((0, _get2["default"])(settings, 'nivoOptions.bar.colors') !== 'custom') {
      return settings;
    }
    var result = (0, _cloneDeep2["default"])(settings);
    (0, _unset2["default"])(result, 'nivoOptions.bar.colors');
    (0, _unset2["default"])(result, 'nivoOptions.bar.customColors');
    return result;
  }();
  var initialMetricSettings = combine(getInitialMetricSettings(metric), overrideInitialSettings);
  return combine(initialMetricSettings, adjustedSettings);
}
function getMetricSettingsToSave(metric, values) {
  var initialMetricSettings = getInitialMetricSettings(metric);
  var diff = getDiff(initialMetricSettings, values);
  if ((0, _isEmpty2["default"])(diff)) {
    return null;
  }
  return diff;
}
function getDiff(obj1, obj2) {
  var diff = (0, _deepObjectDiff.updatedDiff)(obj1, obj2);
  if ((0, _isEmpty2["default"])(diff)) {
    return null;
  }
  return diff;
}
function combine(obj1, obj2) {
  var diff = getDiff(obj1, obj2);
  (0, _merge2["default"])(obj1, diff);
  return obj1;
}